import React from "react";
import { themed } from "../skins";
const StylableIcon = ({ name, variant, className, title, "data-testid": dataTestId, ...props }) => {
    const variantClass = `icon-${name}${variant ? `-${variant}` : ""}`;
    return (React.createElement("span", { ...props, className: `${className} icon icon-${name} ${variantClass}`, role: "img", title: title ? title : `${name}-icon`, "aria-label": title ? title : `${name}-icon`, "data-testid": dataTestId || variantClass }));
};
export const Icon = themed(StylableIcon);
//# sourceMappingURL=Icon.js.map